import React, { useEffect } from 'react';
import { Button, Tab,
  TabList, mergeClasses } from '@fluentui/react-components';
import {
  ArrowLeftFilled,
  ColorBackground20Regular,
} from '@fluentui/react-icons';
import {
  HollowSparkleSVGIcon,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { setClarityTag } from '@bingads-webui-universal/clarity';
import { usePageActiveTimeTracker } from '@bingads-webui-campaign-react/common-hooks';

import { ImagePreviewView } from '../image-preview-view';
import { useBackgroundChangeStyles } from './style';
import { tabs, useControlViewFactoryWithState } from './state';
import { BackgroundChangeDisclaimer } from '../../../background-change-disclaimer';

export const BackgroundChangeView = (props) => {
  const {
    i18n,
    MultiLineEllipsisText,
    goToImageAdjustView,
    imageUrlWithoutBackground,
    drawColorBackground,
    imageUrlWithColoredBackground,
    imageUrlWithGeneratedBackground,
    setImageUrlWithGeneratedBackground,
    logger,
    originalImage,
    resultImage,
    getMaskValueAtPoint,
    segmentationMasks,
    setSelectedImageSrc,
    selectedImageSrc, // the image after user selected objects
    selectedMasks,
    setSelectedMasks,
    maskValues,
    fetchSegmentationError,
    isFetchingSegmentations,
    getSegmentations,
    generateBackground,
    generateMultipleImageBackgrounds,
    onApplyImage,
    permissions,
  } = props;

  const classes = useBackgroundChangeStyles();

  const {
    colorControlView,
    promptControlView,
    buttonsConfig,
    imageView,
    notificationConfig,
    selectedTab,
    onTabSelect,
    buttonsRef,
    isRemovingBackground,
  } = useControlViewFactoryWithState({
    i18n,
    logger,
    originalImage,
    resultImage,
    goToImageAdjustView,
    getSegmentations,
    generateBackground,
    generateMultipleImageBackgrounds,
    drawColorBackground,
    imageUrlWithColoredBackground,
    imageUrlWithoutBackground,
    imageUrlWithGeneratedBackground,
    setImageUrlWithGeneratedBackground,
    getMaskValueAtPoint,
    segmentationMasks,
    setSelectedImageSrc,
    selectedImageSrc,
    selectedMasks,
    setSelectedMasks,
    maskValues,
    fetchSegmentationError,
    isFetchingSegmentations,
    MultiLineEllipsisText,
    applyImage: onApplyImage,
    permissions,
  });

  usePageActiveTimeTracker(logger, 'background change:');

  useEffect(() => {
    setClarityTag({ LoadAdsStudioBackgroundRemovalPage: true });
  }, []);

  return (
    <div className={mergeClasses(classes, 'background-change-page')}>
      <div className="control-section">
        <div className="back-to-adjust">
          <Button
            appearance="subtle"
            icon={<ArrowLeftFilled height="10px" width="10px" />}
            onClick={() => { goToImageAdjustView(); }}
          >
            {i18n.getString(_TL_('Adjust'))}
          </Button>
        </div>
        <div className="background-change-tabs">
          <TabList selectedValue={selectedTab} onTabSelect={onTabSelect}>
            <Tab
              value={tabs.AI}
              icon={<HollowSparkleSVGIcon />}
              disabled={isRemovingBackground || fetchSegmentationError !== ''}
            >
              {i18n.getString(_TL_('Expand background'))}
            </Tab>
            <Tab
              disabled={isRemovingBackground || fetchSegmentationError !== ''}
              value={tabs.SolidColor}
              icon={<ColorBackground20Regular />}
            >
              {i18n.getString(_TL_('Solid color'))}
            </Tab>
          </TabList>
        </div>
        {selectedTab === tabs.AI && (promptControlView)}
        {selectedTab === tabs.SolidColor && (colorControlView)}
      </div>
      <div className="image-section">
        <BackgroundChangeDisclaimer i18n={i18n} />
        <ImagePreviewView
          imageView={imageView}
          buttonsConfig={buttonsConfig}
          buttonsRef={buttonsRef}
          notificationConfig={notificationConfig}
          permissions={permissions}
        />
      </div>
    </div>
  );
};
